<div class="progressBarWrapper">
    <ng-container *ngFor="let i of steps">
        <div *ngIf="i>1" class="betweenSteps"></div>
        <div [class]="classesForStep(i)"></div>
    </ng-container>
</div>